import { useEffect } from 'react';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import {
  CreditCard3d2AuthResponse,
  CreditCard3dVerifyStatus,
  GetCc3DAuthQuery,
  useGetCc3DAuthQuery,
} from '@/lib/apollo/types/gen/graphql';
import { dayjst } from '@/lib/dayjst';

import { IFrameContainer } from './style';

export interface Cc3D2AuthProps {
  authResponse: CreditCard3d2AuthResponse;
  onSuccess: () => void;
  onFailure: () => void;
  onTimeout: () => void;
}

const Cc3D2Auth: React.FC<Cc3D2AuthProps> = ({
  authResponse,
  onSuccess = () => {},
  onFailure = () => {},
  onTimeout = () => {},
}) => {
  // 3Dセキュア認証状況を監視
  const cc3DAuth = useGetCc3DAuthQuery({
    variables: {
      md: authResponse.md,
    },
    pollInterval: 3000,
    fetchPolicy: 'network-only',
    // これは通信状況の監視を行うかのフラグ: 通信のカウント取りたい場合は「true」にする
    notifyOnNetworkStatusChange: true,
  });

  const [pollCnt, setPollCnt] = React.useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const outputLogs = (logTitle: string) => {
    if (queryParams.get('view_charge_log') === 'on') {
      const nowISO = dayjst().toISOString();
      console.log(
        `${nowISO}: ${logTitle}: ${pollCnt}: ${cc3DAuth.loading}: ${cc3DAuth.data?.cc3DAuth.result}`,
      );
    }
  };

  const checkCc3DAuthStatus = (args: GetCc3DAuthQuery | undefined) => {
    outputLogs('checkCc3DAuthStatus');
    if (args) {
      if (args.cc3DAuth.result === CreditCard3dVerifyStatus.Success) {
        cc3DAuth.stopPolling();
        onSuccess();
      } else if (args.cc3DAuth.result === CreditCard3dVerifyStatus.Failure) {
        cc3DAuth.stopPolling();
        onFailure();
      }
    }
  };

  useEffect(() => {
    outputLogs('loading-useEffect');
    if (!cc3DAuth.loading) {
      setPollCnt(pollCnt + 1);

      if (pollCnt > 12) {
        cc3DAuth.stopPolling();
        onTimeout();
      } else {
        checkCc3DAuthStatus(cc3DAuth.data);
      }
    }
  }, [cc3DAuth.loading]);

  // モーダルが閉じられたらポーリングを止める
  useEffect(() => {
    return () => cc3DAuth.stopPolling();
  }, []);

  return (
    <>
      {authResponse.merchant === 'DGFT' && (
        <IFrameContainer srcDoc={authResponse.iframeUrl} />
      )}
    </>
  );
};

export default Cc3D2Auth;
